import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import SignInModal from './SignInModal';
import RegisterModal from './RegisterModal';
import EmailVerificationModal from './EmailVerificationModal';
import PreferencesModal from './PreferencesModal';
import { useTranslation } from 'react-i18next';
import { useSpinWheelEnabled } from '../../hooks/useSpinWheelEnabled';

export default function AuthMenu() {
  const { state, logout } = useAuth();
  const { t } = useTranslation();
  const spinWheelEnabled = useSpinWheelEnabled();
  const [open, setOpen] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showVerify, setShowVerify] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState<string | undefined>(undefined);
  const [showPrefs, setShowPrefs] = useState(false);

  if (state.loading) {
    return (
      <div className="relative">
        <div className="h-9 w-28 rounded-lg bg-gray-800 animate-pulse" aria-hidden />
      </div>
    );
  }

  return (
    <div className="relative">
      {state.user ? (
        <>
          <button onClick={() => setOpen((s) => !s)} className="flex items-center gap-2 px-3 py-2 border border-pink-600/40 rounded-lg text-sm text-gray-300 hover:text-white">
            <span>{state.user.displayName}</span>
          </button>
          {open && (
            <div className="absolute right-0 mt-2 w-56 bg-gray-900 border border-gray-800 rounded-lg shadow-xl z-50">
              <div className="px-4 py-3 border-b border-gray-800 text-sm text-gray-300">
                <div className="font-semibold text-white">{state.user.displayName}</div>
                <div className="text-xs text-gray-400">{state.user.email || state.user.provider}</div>
              </div>
              <button onClick={() => { setShowPrefs(true); setOpen(false); }} className="w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-gray-800">
                {t('prefs.menu', 'Privacy preferences')}
              </button>
              {spinWheelEnabled !== false && (
                <Link to="/spin" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-300 hover:bg-gray-800">
                  {t('nav.spin', 'Spin & Win')}
                </Link>
              )}
              <button onClick={logout} className="w-full text-left px-4 py-2 text-sm text-red-300 hover:bg-gray-800">{t('auth.signOut')}</button>
            </div>
          )}
        </>
      ) : (
        <>
          <button onClick={() => setShowSignIn(true)} className="bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">{t('auth.signIn')}</button>
          <SignInModal isOpen={showSignIn} onClose={() => setShowSignIn(false)} onOpenRegister={() => { setShowSignIn(false); setShowRegister(true); }} />
          <RegisterModal isOpen={showRegister} onClose={() => setShowRegister(false)} onOpenSignIn={() => { setShowRegister(false); setShowSignIn(true); }} onRegistered={(email) => { setRegisteredEmail(email); setShowVerify(true); }} />
          <EmailVerificationModal isOpen={showVerify} email={registeredEmail} onClose={() => setShowVerify(false)} />
        </>
      )}
      <PreferencesModal isOpen={showPrefs} onClose={() => setShowPrefs(false)} />
    </div>
  );
}


